import React from 'react'
import { Button } from '@/components/ui/button'
import { Sparkles, BookOpen, ArrowUp } from 'lucide-react'

export type HomeButtonsProps = {
  showBackToPricing?: boolean
  showPricingCta?: boolean
  pricingCtaText?: string
}
export const HomeButtons = ({
  showBackToPricing = false,
  showPricingCta = true,
  pricingCtaText = 'See pricing',
}: HomeButtonsProps) => {
  return (
    <>
      {showBackToPricing && (
        <Button size="lg" variant="outline" asChild>
          <a href="#pricing" className="flex items-center">
            Back to pricing <ArrowUp className="ml-2 h-4 w-4" />
          </a>
        </Button>
      )}
      {showPricingCta && !showBackToPricing && (
        <Button size="lg" variant="outline" asChild>
          <a href="#pricing" className="flex items-center">
            {pricingCtaText}
          </a>
        </Button>
      )}
      <Button
        size="lg"
        variant="outline"
        asChild
      >
        <a href={'#features'} className="flex items-center">
          All features <Sparkles className="ml-2 h-4 w-4" />
        </a>
      </Button>
      <Button size="lg" variant="outline" asChild>
        <a
          href="https://react-native-google-signin.github.io/docs/install#premium"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center"
        >
          Documentation <BookOpen className="ml-2 h-4 w-4" />
        </a>
      </Button>
    </>
  )
}
